import { FiCode, FiServer, FiShield, FiCheck } from "react-icons/fi";
import SectionHeading from "../../components/SectionHeading";
import SectionArt from "../../components/SectionArt";
import Reveal from "../../components/Reveal";
import TiltCard from "../../components/TiltCard";

const services = [
  {
    icon: FiCode,
    title: "Full-Stack Development",
    accent: "from-aurora-cyan to-aurora-indigo",
    desc: "Scalable web and mobile apps built end to end — from REST APIs to polished UI.",
    points: [
      "Fullstack web & mobile",
      "REST API design",
      "Microservices architecture",
      "Testing & code review",
    ],
  },
  {
    icon: FiServer,
    title: "DevOps & Cloud",
    accent: "from-aurora-violet to-aurora-purple",
    desc: "Ship and scale reliably on modern cloud infrastructure with automated delivery.",
    points: [
      "AWS · Azure AKS · GCP",
      "Docker & Kubernetes",
      "CI/CD pipelines",
      "Monitoring & observability",
    ],
  },
  {
    icon: FiShield,
    title: "IAM & Security",
    accent: "from-aurora-pink to-aurora-rose",
    desc: "Secure identity and access — from protocols to enterprise governance platforms.",
    points: [
      "OAuth2 · OIDC · SAML",
      "One Identity & SailPoint",
      "Keycloak & ForgeRock",
      "RBAC & user lifecycle",
    ],
  },
];

const Services = () => {
  return (
    <section id="services" className="relative px-6 py-28 md:py-36">
      <div className="container mx-auto max-w-6xl">
        <SectionArt type="services" className="mx-auto mb-4 h-32 w-44" />
        <SectionHeading
          eyebrow="What I Offer"
          title="Services"
          subtitle="End-to-end help bringing your product to life — from first sketch to shipped, polished release."
        />

        <div className="grid gap-6 md:grid-cols-3">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} direction="up" delay={i * 0.1}>
                <TiltCard className="group glass relative h-full overflow-hidden rounded-3xl p-8">
                  <div
                    className={`absolute -right-10 -top-10 h-32 w-32 rounded-full bg-gradient-to-br ${s.accent} opacity-20 blur-2xl transition-opacity duration-500 group-hover:opacity-40`}
                  />
                  <span
                    className={`relative flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br ${s.accent} text-2xl text-white shadow-glow`}
                  >
                    <Icon />
                  </span>

                  <h3 className="relative mt-6 text-2xl font-semibold text-content">
                    {s.title}
                  </h3>
                  <p className="relative mt-2 text-sm leading-relaxed text-muted">
                    {s.desc}
                  </p>

                  <ul className="relative mt-6 space-y-3">
                    {s.points.map((p) => (
                      <li
                        key={p}
                        className="flex items-center gap-3 text-sm text-muted"
                      >
                        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-fill-2 text-[11px] text-content">
                          <FiCheck />
                        </span>
                        {p}
                      </li>
                    ))}
                  </ul>
                </TiltCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
